<template>
  <div>
    <RevContainer class="bg-surface-default-low pb-18 md:pb-48">
      <Breadcrumb
        :breads="[
          {
            label: i18n(translations.breadcrumbLabel),
            url: i18n(translations.addToCartLink),
          },
          {
            label: i18n(translations.breadcrumbProductTitle),
            url: '',
          },
        ]"
        class="bg-surface-default-low"
        trackingZone="product_iphone_17"
      />
      <div class="flex flex-col flex-wrap md:flex-row md:flex-nowrap">
        <div class="relative w-full max-w-full grow-0 md:w-1/3 lg:w-1/2">
          <div class="top-[7rem] md:sticky md:right-1/2 md:mr-56">
            <Gallery />
          </div>
        </div>

        <TheMainContent
          class="w-full max-w-full grow-0 md:w-2/3 md:basis-2/3 lg:w-1/2 lg:basis-1/2"
        >
          <h1 class="punchline mt-24 flex flex-col md:mt-0">
            <span>
              {{ i18n(translations.title) }}
            </span>
            <span class="mt-24">
              {{ i18n(translations.title2) }}
            </span>
          </h1>
          <RevButton
            class="mt-24 min-w-[164px] max-w-[256px]"
            :to="i18n(translations.addToCartLink)"
            variant="primary"
            @click="handleAddToCartClick"
          >
            {{ i18n(translations.addToCart) }}
          </RevButton>
          <div class="mt-24">{{ i18n(translations.explanation) }}</div>
          <div class="mt-24">{{ i18n(translations.explanation2) }}</div>
          <div class="caption mt-24">{{ i18n(translations.disclaimer) }}</div>
          <Faq class="mt-24" />
        </TheMainContent>
      </div>
    </RevContainer>
  </div>
</template>

<script setup lang="ts">
import { useHead, useRequestURL, useRouter, useRuntimeConfig } from '#imports'
import { onMounted } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevContainer } from '@ds/components/Container'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'
import Breadcrumb from '~/scopes/navigation/components/Breadcrumb/Breadcrumb.vue'
import { PRODUCT } from '~/scopes/product-core/route-names'
import { getMetas } from '~/utils/seo/meta'

import translations from './Iphone17EventPage.translations'
import Faq from './components/Faq/Faq.vue'
import Gallery from './components/Gallery/Gallery.vue'

const i18n = useI18n()
const runtimeConfig = useRuntimeConfig()
const { protocol, hostname } = useRequestURL()
const router = useRouter()
const { trackClick, trackProductPage } = useTracking()

useHead({
  title: `${i18n(translations.metaTitle)} | ${runtimeConfig.public.COMPANY_NAME}`,
  meta: getMetas({
    title: `${i18n(translations.metaTitle)} | ${runtimeConfig.public.COMPANY_NAME}`,
    description: i18n(translations.metaDescription),
  }),
  link: [
    {
      href: `${protocol}//${hostname}${router.resolve(toNuxtLink({ name: PRODUCT.MASTER_PP })).href}`,
      rel: 'canonical',
    },
  ],
})

function handleAddToCartClick() {
  trackClick({
    zone: 'pp_samsungS26',
    name: 'see_similar_product',
  })
}

onMounted(() => {
  trackProductPage({
    available: false,
    brand: 'Apple',
    category: 'Smartphone',
    model: 'Samsung S26',
  })
})
</script>
